import axiosBase from "api/axiosBase";

export const apiLoadNewsDetail = () => axiosBase.get("news/all");
